import { NgModule } from '@angular/core';
import {CachingService} from './services/caching/caching.service';
import {PlayerStudioService} from './services/PlayerService/player.studio.service';
import {EventParams} from "./services/EventParams/event.params";
import {SignageLibsModuleCommon} from "./signage-libs.module.common";



@NgModule({
    declarations: [
    ],
    imports: [
      SignageLibsModuleCommon,
    ],
    exports: [
    ],
    providers: [
      {
        provide: 'cachingService',
        useClass: CachingService
      },
      {
        provide: 'playerService',
        useClass: PlayerStudioService
      },
      {
        provide: 'eventParams',
        useClass: EventParams
      }
    ],
    bootstrap: []
})
export class SignageLibsModuleStudio { }
